import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  private profileReload = new Subject<any>();
  private dropdownReload = new Subject<any>();

  sendReloadEvent() {
    this.profileReload.next('reload');
  }

  getReloadEvent(): Observable<any> {
    return this.profileReload.asObservable();
  }

  sendDropdownReloadEvent() {
    this.dropdownReload.next('reload');
  }

  getDropdownReloadEvent(): Observable<any> {
    return this.dropdownReload.asObservable();
  }
}
